export default __webpack_public_path__ + "static/media/dry_cleaning.3ad50397.svg";